export var EventEnum;
(function (EventEnum) {
    EventEnum["AddShop"] = "AddShop";
    EventEnum["AddSuggestion"] = "AddSuggestion";
    EventEnum["FilterSelection"] = "FilterSelection";
    EventEnum["Search"] = "Search";
    EventEnum["Sort"] = "Sort";
    EventEnum["ProductClick"] = "ProductClick";
    EventEnum["CategoryClick"] = "CategoryClick";
    EventEnum["MapPinClick"] = "MapPinClick";
    EventEnum["MapTooltipActionClick"] = "MapTooltipActionClick";
    EventEnum["PageVisit"] = "PageVisit";
    EventEnum["FetchMore"] = "FetchMore";
    EventEnum["NotificationBar"] = "NotificationBar";
    EventEnum["ReportTypeSwitcher"] = "ReportTypeSwitcher";
    EventEnum["ReportNextButton"] = "ReportNextButton";
    EventEnum["ReportBackButton"] = "ReportBackButton";
    EventEnum["ReportTypeSwitcherButton"] = "ReportTypeSwitcherButton";
    EventEnum["ReportCTA"] = "ReportCTA";
    EventEnum["ThemeSwitcher"] = "ThemeSwitcher";
    EventEnum["NewsletterChecklistCTADVisible"] = "NewsletterChecklistCTAVisible";
    EventEnum["NewsletterChecklistCTAClick"] = "NewsletterChecklistCTAClick";
    EventEnum["MenuButton"] = "MenuButton";
})(EventEnum || (EventEnum = {}));
